import React from 'react';

import { useParams } from 'react-router-dom';

import CategoryPage from './CategoryPage';
import {
  PageContainer,
} from './index.styles';
import RootPage from './RootPage';
import TopicPage from './TopicPage';

const AdminVideosPage = () => {
  const { subject, category, topic } = useParams();

  return (
    <PageContainer>
      {(subject && category && topic) && (
        <TopicPage
          subject={subject}
          category={category}
          topic={topic}
        />
      )}
      {(subject && category && !topic) && (
        <CategoryPage
          subject={subject}
          category={category}
        />
      )}
      {!(subject && category) && (
        <RootPage />
      )}
    </PageContainer>
  );
};

export default AdminVideosPage;
